/* 财务-文旅行程 */
<template>
  <div id="financial">
    <custom-table ref="customTable" :has-organization="true" :customOptions="customOptions" :columns="columns"
       labelWidth="95" excel-type="TravelFinanceFlowing" :summaryList="[
        { name: 'fee', beforeUnit: '￥' },
        { name: 'driverIncome', beforeUnit: '￥' },
        { name: 'platformIncome', beforeUnit: '￥' },
      ]">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">
          {{ row.created | filterTime("YYYY-MM-DD HH:mm") }}
        </template>
        <template v-else-if="['fee', , 'driverIncome', 'platformIncome'].includes(item.prop)">
          <span class="util-money" v-if="row[item.prop] || row[item.prop] === 0">
            ¥{{ row[item.prop] }}
          </span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
       
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "financial",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/travelOrder/financeFlowing",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "orderDriverNo", name: "行程编号", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
        ],
      },
      // 表头
      columns: [
        { prop: "orderDriverNo", label: "行程编号", width: 200 },
        { prop: "licenseNo", label: "车辆号牌", width: 100 },
        { prop: "driverName", label: "司机姓名", width: 100 },
        { prop: "travelLineName", label: "线路名称", minWidth: 120 },
        { prop: "passengerNum", label: "乘车人数", width: 80 },
        { prop: "fee", label: "行程费用", width: 120 },
        { prop: "driverIncome", label: "司机收入", width: 120 },
        { prop: "platformIncome", label: "平台收入", width: 120 },
        { prop: "created", label: "记录时间", width: 140 }
      ],
    };
  },
  methods: {   
    async getList() {        
      let url = "/api/v1/manage/travelOrder/list";

    },
}
};
</script>

<style scoped></style>
